window.$ = window.jQuery = require('jquery');
import 'bootstrap';
import 'animate.css/animate.css';
import AOS from 'aos';
window.lightbox = require('lightbox2');
window.feather = require('feather-icons');
window.WebFont = require('webfontloader');
import Plyr from 'plyr';
import 'plyr/dist/plyr.polyfilled';
window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'X-Requested-With': 'XMLHttpRequest'
};

lightbox.option({
    'fadeDuration': 200,
    'imageFadeDuration': 200,
    'resizeDuration': 200,
    'wrapAround': true
});

WebFont.load({
    google: {
        families: [
            'Roboto:100,400,700:latin',
            'Noto Sans KR:300,400,700:latin,korean',
            'Noto Serif KR:300,400,700:latin,korean',
            'Trirong:300,400,700'
        ]
    },
    timeout: 2000
});

feather.replace();

AOS.init();
